import React, { useRef, useState } from "react";
import logo from "../imgs/logo.svg";
import styles from "../styles/Topbar.module.scss";
import { useTranslation } from "react-i18next";
import {
  CircularProgress,
  FormControlLabel,
  MenuItem,
  styled,
  Switch,
} from "@mui/material";
import secureLocalStorage from "react-secure-storage";
import { useNavigate } from "react-router-dom";
import MobileMenuDrawer from "./MobileMenuDrawer";
import axios from "axios";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

const CustomMenuItem = styled(MenuItem)(({ theme }) => ({
  backgroundColor: "var(--button-alternative-default, #303034)",
  color: "var(--font-mine)",
  fontFamily: "'Inter', sans-serif",
  fontSize: "14px",
  "&:hover": {
    backgroundColor: "var(--buttons-alternative-hover, #303034)",
  },
  "&.Mui-selected": {
    backgroundColor: "var(--button-alternative-default, #303034) !important",
    "&:hover": {
      backgroundColor: "var(--buttons-alternative-hover, #303034)",
    },
  },
}));
export default function Topbar({
  theme,
  totalBalanceUsd,
  toggleTheme,
  account,
  balance,
  margin,
  usdToEur,
  eurToUsd,
  profit,
  setProfit,
  setSnackType,
  handleClick,
  setSnackMessage,
  assetsListIsOpen,
  applications,
  setAssetsList,
  totalBalanceDemo,
  getAssetNameByAccount,
  getSymbolByAccount
}) {
  const { t, i18n } = useTranslation();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);
  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  const [accountButton, setAccountButton] = useState(false);
  const handleSetAccountButton = () => {
    setAccountButton(!accountButton);
  };

  const Logout = () => {
    secureLocalStorage.removeItem("token");
    secureLocalStorage.removeItem("user");
    nav("/login", { replace: true });
  };

  const languages = [
    {
      value: "en",
      label: "English",
      flag: "https://flagcdn.com/w320/us.png",
    },
    {
      value: "de",
      label: "Deutsch",
      flag: "https://flagcdn.com/w320/de.png",
    },
    {
      value: "cz",
      label: "Czech",
      flag: "https://flagcdn.com/w320/cz.png",
    },
    {
      value: "it",
      label: "Italian",
      flag: "https://flagcdn.com/w320/it.png",
    },
    {
      value: "fr",
      label: "French",
      flag: "https://flagcdn.com/w320/fr.png",
    },
    {
      value: "pl",
      label: "Polish",
      flag: "https://flagcdn.com/w320/pl.png",
    },
    {
      value: "es",
      label: "Español",
      flag: "https://flagcdn.com/w320/es.png",
    },
  ];

  function changeLanguage(e) {
    i18n.changeLanguage(e);
    secureLocalStorage.setItem("lang", e);
  }

  const autoLogin = async () => {
    await axios
      .post(
        process.env.REACT_APP_test_url + `/api/cabinetauth/${account?.Id}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${secureLocalStorage.getItem("token")}`,
          },
        }
      )
      .then((res) => {
        if (window.innerWidth < 600) {
          window.location.href = res.data.autologin_url;
        } else {
          const newWindow = window.open(
            res.data.autologin_url,
            "_blank",
            "noopener,noreferrer"
          );
          if (newWindow) newWindow.opener = null;
        }
      })
      .catch((err) => {});
  };
  const AccountTypeEnum = Object.freeze({
    Real: 'Real',
    Fake: 'Fake'
  });
  
  return (
    <div className={styles.topbar}>
      <div className={styles.mobile_navbar} onClick={toggleDrawer(true)}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={"16px"}
          height={"16px"}
          viewBox="0 0 16 16"
          fill="none"
        >
          <path
            d="M13.3333 4.66699L2.66659 4.66699"
            stroke="#FCFCFC"
            strokeLinecap="round"
          />
          <path
            d="M13.3333 8L2.66659 8"
            stroke="#FCFCFC"
            strokeLinecap="round"
          />
          <path
            d="M13.3333 11.333L2.66659 11.333"
            stroke="#FCFCFC"
            strokeLinecap="round"
          />
        </svg>
      </div>
      <div className={styles.logo}>
        <img src={logo} alt="logo" loading="lazy" />
        <h2>{t("Trading Terminal")}</h2>
        <div className={styles.addition_balance}>
          <div className={styles.account_id}>
            <p># {account?.Id}</p>
            <span>{t("AccountId")}</span>
          </div>
          <div className={styles.account_balance}>
            <p>
              {getSymbolByAccount()}{" "}
              {Math.trunc(
                (balance +
                  applications?.balances?.find(
                    (val) => val?.PlatformId == account?.Id
                  )?.TotalSum) * 100 
              )/100 ? (
                Math.trunc(
                  (balance +
                    applications?.balances?.find(
                      (val) => val?.PlatformId == account?.Id
                    )?.TotalSum) *
                    (account?.AccountCurrency == "EUR" ? eurToUsd : 1)
                    *100
                ) / 100
              ) : (
                <CircularProgress
                  size={"snall"}
                  sx={{ marginLeft: "15px", width: "15px", height: "15px" }}
                />
              )}
            </p>
            <span>{t("Free Margin")}</span>
          </div>
        </div>
      </div>
      <div className={styles.right_side}>
        <div className={styles.balance}>
          {
            account?.AccountType === AccountTypeEnum.Fake
            ?<span className={styles.demo_account}>Demo</span>:''
          }
          {account?.AccountType === AccountTypeEnum.Fake?<div className={styles.inside_balance}>
              <p>{getSymbolByAccount()} {totalBalanceDemo?  account?.AccountCurrency == "EUR"?(totalBalanceDemo * eurToUsd).toFixed(5) :totalBalanceDemo.toFixed(5) :0}</p>
              <span>{t("Total demo balance")}</span>
          </div>
          :
          <div className={styles.inside_balance}>
            <p>
              {getSymbolByAccount()}{" "}
              {parseFloat(
                totalBalanceUsd *
                  (account?.AccountCurrency == "EUR" ? eurToUsd : 1)
              )
                ? Math.trunc(
                    (totalBalanceUsd +
                      applications?.balances?.reduce(
                        (sum, val) => (sum += val?.TotalSum),
                        0
                      )) *
                      (account?.AccountCurrency == "EUR" ? eurToUsd : 1)
                      *100
                  )/100
                : 0}
            </p>
            <span>{t("TotalBalance")}</span>
          </div>}
          <div className={styles.inside_balance}>
            <p>
              {getSymbolByAccount()}{" "}
              {parseFloat(
                margin * (account?.AccountCurrency == "EUR" ? eurToUsd : 1)
              )
                ? Math.trunc(
                    margin * (account?.AccountCurrency == "EUR" ? eurToUsd : 1) * 100
                  )/100
                : 0}
            </p>
            <span>{t("Margin")}</span>
          </div>
          <div className={styles.inside_balance}>
            <p>
              {getSymbolByAccount()}{" "}
              {parseFloat(
                balance +
                  applications?.balances?.find(
                    (val) => val?.PlatformId == account?.Id
                  )?.TotalSum
              ) ? (
                Math.trunc(
                  (balance +
                    applications?.balances?.find(
                      (val) => val?.PlatformId == account?.Id
                    )?.TotalSum) *
                    (account?.AccountCurrency == "EUR" ? eurToUsd : 1)
                    *100
                ) /100
              ) : (
                <CircularProgress
                  size={"snall"}
                  sx={{ marginLeft: "15px", width: "15px", height: "15px" }}
                />
              )}
            </p>
            <span>{t("Free Margin")}</span>
          </div>
          <div className={styles.inside_balance}>
            <p
              style={{
                color:
                  parseFloat(
                    profit * (account?.AccountCurrency == "EUR" ? eurToUsd : 1)
                  ) > 0
                    ? "#35B0BA"
                    : "#4C47A2",
              }}
              className={styles.profit}
            >
              {
                (() => {
                const value = profit * (account?.AccountCurrency == "EUR" ? eurToUsd : 1);
                const absValue = Math.abs(value);

                if (value === 0 || isNaN(value)) {
                    return 0;
                } else if (absValue >= 1) {
                    return value.toFixed(2);
                } else {
                    return value.toFixed(5);
                }
                })()
              }
            </p>
            <span>{t("Open P/L")}</span>
          </div>
        </div>
        <div className={styles.buttons}>
          <FormControl sx={{ minWidth: 50 }}>
            <Select
              value={i18n.language}
              onChange={(e) => changeLanguage(e.target.value)}
              displayEmpty
              inputProps={{ "aria-label": "Without label" }}
              sx={{
                color: "var(--font-mine)",
                fontFamily: "'Inter',sans-serif",
                fontSize: "14px",
                background: "var(--button-alternative-default, #303034)",
                border:
                  "1px solid var(--border-button, rgba(255, 255, 255, 0.08))",
                "& .MuiSelect-select": { padding: "0.7vh !important" },
                "& .MuiSvgIcon-root": {
                  fill: "var(--font-mine)",
                  right: "-1px",
                },
              }}
              MenuProps={{
                MenuListProps: {
                  sx: {
                    "& .MuiMenuItem-root": {
                      backgroundColor:
                        "var(--button-alternative-default, #303034)",
                      color: "var(--font-mine)",
                      fontFamily: "'Inter', sans-serif",
                      fontSize: "14px",
                      "&.Mui-selected": {
                        backgroundColor:
                          "var(--button-alternative-default, #303034) !important",
                      },
                    },
                  },
                },
              }}
            >
              {languages.map((el) => (
                <CustomMenuItem
                  value={el.value}
                  key={el.value}
                  sx={{
                    background: "var(--button-alternative-default, #303034)",
                    color: "var(--font-mine)",
                    fontFamily: "'Inter',sans-serif",
                    fontSize: "14px",
                    "& .Mui-selected": {
                      background:
                        "var(--button-alternative-default, #303034) !important",
                    },
                  }}
                >
                  {el.value.toUpperCase()}
                </CustomMenuItem>
              ))}
            </Select>
          </FormControl>
          <div className={styles.theme}>
            {/* <FormControlLabel
                    sx={{margin:0, '& .MuiSwitch-input':{width:'100%'}}}
                            control={<MaterialUISwitch sx={{ m: 0 }}  />}
                            checked={theme==='light'}
                            onChange={()=> toggleTheme(theme === 'dark'? 'light':'dark')}
                        /> */}
            <div
              className={styles.button}
              onClick={() => toggleTheme(theme === "dark" ? "light" : "dark")}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
              >
                <path d="M14.0449 7.90456L13.403 7.51668L13.403 7.51668L14.0449 7.90456ZM8.09548 1.95517L7.7076 1.31326V1.31326L8.09548 1.95517ZM13.9167 8C13.9167 11.2677 11.2677 13.9167 8.00004 13.9167V15.4167C12.0962 15.4167 15.4167 12.0961 15.4167 8H13.9167ZM8.00004 13.9167C4.73236 13.9167 2.08337 11.2677 2.08337 8H0.583374C0.583374 12.0961 3.90393 15.4167 8.00004 15.4167V13.9167ZM2.08337 8C2.08337 4.73231 4.73236 2.08333 8.00004 2.08333V0.583328C3.90393 0.583328 0.583374 3.90388 0.583374 8H2.08337ZM10.3334 9.25C8.35435 9.25 6.75004 7.64568 6.75004 5.66666H5.25004C5.25004 8.47411 7.52593 10.75 10.3334 10.75V9.25ZM13.403 7.51668C12.7743 8.55713 11.6344 9.25 10.3334 9.25V10.75C12.1811 10.75 13.7978 9.76369 14.6868 8.29244L13.403 7.51668ZM6.75004 5.66666C6.75004 4.36567 7.4429 3.22578 8.48336 2.59708L7.7076 1.31326C6.23634 2.20228 5.25004 3.81893 5.25004 5.66666H6.75004ZM8.00004 2.08333C7.87295 2.08333 7.73869 2.02896 7.64135 1.92765C7.55553 1.83831 7.52719 1.7441 7.51918 1.6848C7.50582 1.58589 7.53448 1.41786 7.7076 1.31326L8.48336 2.59708C8.92048 2.33295 9.05565 1.854 9.00569 1.48405C8.95339 1.0968 8.63955 0.583328 8.00004 0.583328V2.08333ZM14.6868 8.29244C14.5822 8.46555 14.4141 8.49421 14.3152 8.48085C14.2559 8.47285 14.1617 8.4445 14.0724 8.35868C13.9711 8.26135 13.9167 8.12709 13.9167 8H15.4167C15.4167 7.36048 14.9032 7.04665 14.516 6.99435C14.146 6.94439 13.6671 7.07956 13.403 7.51668L14.6868 8.29244Z" />
              </svg>
            </div>
          </div>
          <div className={styles.logout} onClick={autoLogin}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <ellipse
                cx="8.00004"
                cy="3.99999"
                rx="2.66667"
                ry="2.66667"
                stroke="white"
                strokeWidth="1.5"
              />
              <path
                d="M13.3333 11.6667C13.3333 13.3235 13.3333 14.6667 7.99996 14.6667C2.66663 14.6667 2.66663 13.3235 2.66663 11.6667C2.66663 10.0098 5.05444 8.66667 7.99996 8.66667C10.9455 8.66667 13.3333 10.0098 13.3333 11.6667Z"
                stroke="white"
                strokeWidth="1.5"
              />
            </svg>
            {/* {secureLocalStorage.getItem("user")?.FirstName.slice(0, 8)} */}
            {t(`Cabinet`)}
          </div>
          <div className={styles.logout_button} onClick={Logout}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                d="M8 13.3337C5.05448 13.3337 2.66667 10.9458 2.66667 8.00033C2.66667 5.05481 5.05448 2.66699 8 2.66699"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
              <path
                d="M6.66671 8H13.3334M13.3334 8L11.3334 6M13.3334 8L11.3334 10"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        </div>
      </div>

      <MobileMenuDrawer
        getAssetNameByAccount={getAssetNameByAccount}
        getSymbolByAccount={getSymbolByAccount}
        totalBalanceUsd={totalBalanceUsd}
        handleClick={handleClick}
        setSnackMessage={setSnackMessage}
        setSnackType={setSnackType}
        profit={profit}
        account={account}
        eurToUsd={eurToUsd}
        balance={balance}
        margin={margin}
        open={open}
        theme={theme}
        toggleDrawer={toggleDrawer}
        toggleTheme={toggleTheme}
        totalBalanceDemo={totalBalanceDemo}
        applications={applications}
      />
    </div>
  );
}
